import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import TdsLink from '@tds/core-link';

import { PaginationWrapper, PaginationContainer, Page } from './css';

const getPages = (step, total) => {
  const pages = [];
  let page = 1;
  let index = 1;

  while (index <= total) {
    pages.push(page);
    page += 1;
    index += step;
  }

  return pages;
};

const Pagination = ({ count, step, currentPage, url }) => {
  const totalPages = 5;
  const pages = getPages(step, count);
  const getUrl = page => (url ? url.concat(`&page=${page}`) : `?page=${page}`);
  return (
    <>
      {(count > currentPage * step || currentPage > 1) && (
        <PaginationWrapper>
          <PaginationContainer>
            {currentPage > 1 && totalPages < pages.length && (
              <TdsLink to={getUrl(1)} reactRouterLinkComponent={RouterLink}>
                <Page>{'<<'}</Page>
              </TdsLink>
            )}
            {pages.map(item => {
              const isVisible =
                pages.length <= totalPages ||
                (item < currentPage + 3 && item > currentPage - 3) ||
                ((currentPage === 1 || currentPage === 2) &&
                  item <= totalPages) ||
                (currentPage === pages.length &&
                  item >= pages.length - totalPages) ||
                (currentPage === pages.length - 1 &&
                  item > pages.length - totalPages);
              const elem = (
                <Page item={item} currentPage={currentPage}>
                  {item}
                </Page>
              );

              return (
                isVisible && (
                  <Fragment key={`page${item}`}>
                    {item === currentPage ? (
                      elem
                    ) : (
                      <TdsLink
                        to={getUrl(item)}
                        reactRouterLinkComponent={RouterLink}
                      >
                        {elem}
                      </TdsLink>
                    )}
                  </Fragment>
                )
              );
            })}
            {currentPage < pages.length && totalPages < pages.length && (
              <TdsLink
                to={getUrl(pages.length)}
                reactRouterLinkComponent={RouterLink}
              >
                <Page>{'>>'}</Page>
              </TdsLink>
            )}
          </PaginationContainer>
        </PaginationWrapper>
      )}
    </>
  );
};

Pagination.propTypes = {
  count: PropTypes.number.isRequired,
  step: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired
};

export default Pagination;
